import React from "react";
import Navbar from "./WireComponents/Navbar";
import Landing from "./WireComponents/Landing";
import About from "./WireComponents/About";
import Product from "./WireComponents/Product";
import Contact from "./LandingComponents/Contact/Contact";
import Footer from "./WireComponents/Footer";

const WirePage = ({ setCurrentPage }) => {
  return (
    <>
      <Navbar setCurrentPage={setCurrentPage}/>
      <Landing />
      <About />
      <Product />
      <Contact />
      <Footer />
    </>
  );
};

export default WirePage;
